/**
* This file was auto-generated by the FrontendConstantsGenerator.
* Do not make direct changes to the file.
*/

// TODO: TDW-SUNSET

import { PILL_COLORS } from '@user-interviews/ui-design-system';

export const IntegrationProviders = {
  CUSTOM_LINK: 'custom_link',
  LOOKBACK: 'lookback',
  QUALTRICS: 'qualtrics',
  SURVEYMONKEY: 'surveymonkey',
  NO_LINK: 'no_link',
  TRACKED_PROVIDERS: ["ai_moderated","alchemer_redirect","ballpark_redirect","custom_link_with_redirect","lookback","loop11","lyssna_redirect","maze_redirect","optimal_redirect","qualtrics","sprig","surveymonkey","typeform","user_testing_redirect","user_zoom"],
};

export const FraudReportStatuses = {
  PENDING_REVIEW: 'pending_review',
  FRAUDULENT: 'fraudulent',
  NOT_FRAUDULENT: 'not_fraudulent',
}

export const CompensationMethods = {"WE_PAY":2,"THEY_PAY":3,"NONE":4}

export const CompensationDistributedBy = {
  "they_pay": "Your team",
  "we_pay": "User Interviews",
};

export const CompensationDistributedBySessionsCard = {
  "they_pay": "your team",
  "we_pay": "User Interviews",
};

export const CompleteSortedDeviceRequirements = {
  device: [{"id":1,"display_name":"Computer with webcam","display_order":1,"llm_tool_key":"computer_with_webcam","type_key":"device","slug":"device--computer_with_webcam","type":"Device type"},{"id":4,"display_name":"Computer","display_order":2,"llm_tool_key":"computer","type_key":"device","slug":"device--computer","type":"Device type"},{"id":3,"display_name":"Tablet","display_order":3,"llm_tool_key":"tablet","type_key":"device","slug":"device--tablet","type":"Device type"},{"id":2,"display_name":"Smartphone","display_order":4,"llm_tool_key":"smartphone","type_key":"device","slug":"device--smartphone","type":"Device type"}],
  browser: [{"id":6,"display_name":"Google Chrome","display_order":1,"llm_tool_key":"google_chrome","type_key":"browser","slug":"browser--google_chrome","type":"Web browser"},{"id":7,"display_name":"Safari","display_order":2,"llm_tool_key":"safari","type_key":"browser","slug":"browser--safari","type":"Web browser"},{"id":8,"display_name":"Firefox","display_order":3,"llm_tool_key":"firefox","type_key":"browser","slug":"browser--firefox","type":"Web browser"},{"id":9,"display_name":"Microsoft Edge","display_order":4,"llm_tool_key":"microsoft_edge","type_key":"browser","slug":"browser--microsoft_edge","type":"Web browser"},{"id":10,"display_name":"Brave","display_order":5,"llm_tool_key":"brave","type_key":"browser","slug":"browser--brave","type":"Web browser"},{"id":11,"display_name":"Other","display_order":6,"llm_tool_key":"other_browser","type_key":"browser","slug":"browser--other_browser","type":"Web browser"}],
  os: [{"id":12,"display_name":"Chrome OS","display_order":1,"llm_tool_key":"chrome_os","type_key":"os","slug":"os--chrome_os","type":"Computer operating system"},{"id":13,"display_name":"MacOS","display_order":2,"llm_tool_key":"mac_os","type_key":"os","slug":"os--mac_os","type":"Computer operating system"},{"id":14,"display_name":"Windows","display_order":3,"llm_tool_key":"windows","type_key":"os","slug":"os--windows","type":"Computer operating system"},{"id":15,"display_name":"GNU/Linux or Unix","display_order":4,"llm_tool_key":"gnu_linux_or_unix","type_key":"os","slug":"os--gnu_linux_or_unix","type":"Computer operating system"},{"id":16,"display_name":"Other","display_order":5,"llm_tool_key":"other_os","type_key":"os","slug":"os--other_os","type":"Computer operating system"}],
  recording: [{"id":17,"display_name":"Audio","display_order":1,"llm_tool_key":"audio_recording","type_key":"recording","slug":"recording--audio","type":"Session recording notification"},{"id":18,"display_name":"Video","display_order":2,"llm_tool_key":"video_recording","type_key":"recording","slug":"recording--video","type":"Session recording notification"},{"id":19,"display_name":"Screen","display_order":3,"llm_tool_key":"screen_recording","type_key":"recording","slug":"recording--screen","type":"Session recording notification"}],
}

export const DeviceRequirementTypes = {"device":"Device type","browser":"Web browser","os":"Computer operating system","recording":"Session recording notification"}

export const DefaultDeviceRequirements = {
  online: [1],
  phone: [2],
}

export const FilterTypes = {
  PRIVATE: 'private',
  PUBLIC: 'public',
}

export const FlagTypes = {
  ADVANCED_SCREENING: 'advanced_screening',
  CUSTOM: 'custom',
  IMPORTANCE_LEVEL: 'importance_level',
  NEEDS_ADS: 'needs_ads',
  OCCUPATION_TARGETING: 'occupation_targeting'
};

export const OccupationTypes = {
  PRODUCT_MANAGER: 'product_manager',
  IT: 'it',
  CEO: 'ceo',
  OWNER: 'owner',
  SOFTWARE: 'software',
  DATA: 'data',
};

export const OccupationTypesDisplayNames = {
  product_manager: 'Product Manager',
  it: 'IT',
  ceo: 'CEO',
  owner: 'Owner',
  software: 'Software',
  data: 'Data',
}

export const OccupationTypesOptions = [
  {
    label: OccupationTypesDisplayNames[OccupationTypes.SOFTWARE as keyof typeof OccupationTypesDisplayNames],
    value: OccupationTypes.SOFTWARE,
  },
  {
    label: OccupationTypesDisplayNames[OccupationTypes.IT as keyof typeof OccupationTypesDisplayNames],
    value: OccupationTypes.IT,
  },
  {
    label: OccupationTypesDisplayNames[OccupationTypes.PRODUCT_MANAGER as keyof typeof OccupationTypesDisplayNames],
    value: OccupationTypes.PRODUCT_MANAGER,
  },
  {
    label: OccupationTypesDisplayNames[OccupationTypes.CEO as keyof typeof OccupationTypesDisplayNames],
    value: OccupationTypes.CEO,
  },
  {
    label: OccupationTypesDisplayNames[OccupationTypes.OWNER as keyof typeof OccupationTypesDisplayNames],
    value: OccupationTypes.OWNER,
  },
  {
    label: OccupationTypesDisplayNames[OccupationTypes.DATA as keyof typeof OccupationTypesDisplayNames],
    value: OccupationTypes.DATA,
  },
];

export const InterviewTypes = {"IN_PERSON":1,"PHONE":2,"ONLINE":4}

export const InterviewTypeEnums = {"IN_PERSON":{"display_name":"In-person","icon_class":"fa-user","id":1,"sort_order":0,"to_sym":"in_person","llm_tool_key":"in_person","transition":{}},"PHONE":{"display_name":"Over the Phone","icon_class":"fa-phone","id":2,"sort_order":1,"to_sym":"phone","llm_tool_key":"over_the_phone","transition":{}},"ONLINE":{"display_name":"Online","icon_class":"fa-globe","id":4,"sort_order":2,"to_sym":"online","llm_tool_key":"online","transition":{}}}

export const InterviewTypesDisplayNames = {
  1: 'In-person',
  2: 'Over the Phone',
  4: 'Online',
}

export const ParticipantFeedbackQualities = {"BAD":0,"AVERAGE":1,"GREAT":2}

export const ParticipantFeedbackDisplayQualities = {"0":"Below expectations","1":"Met expectations","2":"Exceeded expectations"}

export const ParticipantQualifierTypes = {
  DEMOGRAPHIC: 'Recruiting::Qualification::ParticipantQualifiers::DemographicQualifier',
  LOCATION: 'Recruiting::Qualification::ParticipantQualifiers::LocationQualifier',
  PREVIOUS_PROJECT: 'Recruiting::Qualification::ParticipantQualifiers::PreviousProjectQualifier',
  RECRUITABLE: 'Recruiting::Qualification::ParticipantQualifiers::RecruitableQualifier',
};

export const ParticipantStatuses = {"UNSORTED":0,"UNQUALIFIED":1,"QUALIFIED":2,"REJECTED":3,"APPROVED":4,"RESEARCHER_CANCELED":5,"CONFIRMED":6,"PAID":7,"INTERVIEW_COMPLETED":8,"NO_SHOW":9,"PARTICIPANT_CANCELED":10,"PREQUALIFIED":11,"RESEARCHER_RESCHEDULED":12,"PARTICIPANT_RESCHEDULED":13,"QUALIFIED_NEEDS_REVIEW":14,"FRAUDULENT":15,"POTENTIAL":16} as const;

export const UnmoderatedStatusDisplayNames = {
  "0": "Unsorted",
  "1": "Unqualified",
  "2": "Qualified",
  "3": "Not a fit",
  "4": "Approved",
  "5": "Researcher canceled",
  "6": "Started",
  "7": "Paid",
  "8": "Marked complete",
  "9": "Task Not Completed",
  "10": "Participant canceled",
  "11": "Pre-qualified",
  "12": "Researcher rescheduled",
  "13": "Participant rescheduled",
  "14": "Qualified (needs review)",
  "15": "Fraudulent",
  "16": "Potential"
} as const;

export const ModeratedStatusDisplayNames = {
  "0": "Unsorted",
  "1": "Unqualified",
  "2": "Qualified",
  "3": "Not a fit",
  "4": "Approved",
  "5": "Researcher canceled",
  "6": "Confirmed",
  "7": "Paid",
  "8": "Interview completed",
  "9": "Did not show",
  "10": "Participant canceled",
  "11": "Pre-qualified",
  "12": "Researcher rescheduled",
  "13": "Participant rescheduled",
  "14": "Qualified (needs review)",
  "15": "Fraudulent",
  "16": "Potential"
} as const;

export const ParticipantReviewTiers = {
  NOT_REVIEWED: 1,
  GOOD: 100,
  OK: 60,
  BAD: 20,
};

export const ProjectDefaultName = "Unnamed Project"

export const ProjectRoles = {
  EDIT: 'Edit',
  OWNER: 'Owner',
  VIEW: 'View',
};

export const ProjectSettings = {"annotationsEnabled":{"key":"annotationsEnabled","default":false,"type":"boolean"},"automaticNotifications":{"key":"automaticNotifications","default":true,"type":"boolean"},"confirmOnJoin":{"key":"confirmOnJoin","default":true,"type":"boolean"},"disableAutopay":{"key":"disableAutopay","default":false,"type":"boolean"},"doNotClose":{"key":"doNotClose","default":false,"type":"boolean"},"emailTrackingEnabled":{"key":"emailTrackingEnabled","default":false,"type":"boolean"},"hideFromBrowse":{"key":"hideFromBrowse","default":false,"type":"boolean"},"hideResearchDesignFromViewers":{"key":"hideResearchDesignFromViewers","default":false,"type":"boolean"},"hubInviteBatchLimit":{"key":"hubInviteBatchLimit","default":0,"type":"integer"},"legacyDopeTableDefaults":{"key":"legacyDopeTableDefaults","default":false,"type":"boolean"},"limitPreviousParticipants":{"key":"limitPreviousParticipants","default":true,"type":"boolean"},"limitedFunnelStagesForViewers":{"key":"limitedFunnelStagesForViewers","default":false,"type":"boolean"},"limitedTableConfigForViewers":{"key":"limitedTableConfigForViewers","default":false,"type":"boolean"},"maxAppsPerRequestedParticipant":{"key":"maxAppsPerRequestedParticipant","default":100,"type":"integer"},"notifyApproved":{"key":"notifyApproved","default":true,"type":"boolean"},"overrideUseSmallBatchSize":{"key":"overrideUseSmallBatchSize","default":false,"type":"boolean"},"participantApprovalEnabledForViewers":{"key":"participantApprovalEnabledForViewers","default":false,"type":"boolean"},"participantExportDisabledForViewers":{"key":"participantExportDisabledForViewers","default":false,"type":"boolean"},"participantMessagingDisabledForViewers":{"key":"participantMessagingDisabledForViewers","default":false,"type":"boolean"},"participantProfileDisabledForViewers":{"key":"participantProfileDisabledForViewers","default":false,"type":"boolean"},"participantReschedulingEnabled":{"key":"participantReschedulingEnabled","default":false,"type":"boolean"},"piiDoubleBlindForViewers":{"key":"piiDoubleBlindForViewers","default":false,"type":"boolean"},"preStudyMfeScreenerEnabled":{"key":"preStudyMfeScreenerEnabled","default":false,"type":"boolean"},"previousParticipantWaitDays":{"key":"previousParticipantWaitDays","default":0,"type":"integer"},"projectNotesDisabledForViewers":{"key":"projectNotesDisabledForViewers","default":false,"type":"boolean"},"quotaGatingEnabled":{"key":"quotaGatingEnabled","default":false,"type":"boolean"},"recruitInternational":{"key":"recruitInternational","default":false,"type":"boolean"},"recruitmentMultiplier":{"key":"recruitmentMultiplier","default":2.0,"type":"float"},"recruitmentRadius":{"key":"recruitmentRadius","default":100,"type":"integer"},"requireApproval":{"key":"requireApproval","default":true,"type":"boolean"},"rptInvitesOnly":{"key":"rptInvitesOnly","default":false,"type":"boolean"},"trackCustomTaskLink":{"key":"trackCustomTaskLink","default":false,"type":"boolean"},"waiveProcessingFee":{"key":"waiveProcessingFee","default":false,"type":"boolean"}};

export const ProjectStatuses = {"DRAFT":0,"LAUNCHED":1,"CURRENTLY_RECRUITING":2,"DONE_RECRUITING":4,"COMPLETE_REQUESTED_PAYMENT":5,"COMPLETE_CHARGED":6,"COMPLETE_CANCELED":7,"COMPLETE_DECLINED":8,"PENDING_CLOSE_REQUEST":9}

export const ProjectStatusesById = {
  
  0: {
    id: 0,
    externalName: 'Draft',
    color: PILL_COLORS.YELLOW
  } ,

  1: {
    id: 1,
    externalName: 'Active',
    color: PILL_COLORS.GREEN
  } ,

  2: {
    id: 2,
    externalName: 'Active',
    color: PILL_COLORS.GREEN
  } ,

  4: {
    id: 4,
    externalName: 'Paused',
    color: PILL_COLORS.ORANGE
  } ,

  5: {
    id: 5,
    externalName: 'Completed',
    color: PILL_COLORS.GRAY
  } ,

  6: {
    id: 6,
    externalName: 'Completed',
    color: PILL_COLORS.GRAY
  } ,

  7: {
    id: 7,
    externalName: 'Completed',
    color: PILL_COLORS.GRAY
  } ,

  8: {
    id: 8,
    externalName: 'Completed',
    color: PILL_COLORS.GRAY
  } ,

  9: {
    id: 9,
    externalName: 'Pending Close Request',
    color: PILL_COLORS.BLUE
  } 

};


export const StudyTypes = {"ONE_ON_ONE":1,"FOCUS_GROUP":2,"MULTI_DAY":3,"UNMODERATED_TASK":4}

export const StudyTypesDisplayNames = {
  1: '1-on-1 Interview',
  2: 'Focus Group',
  3: 'Multi Day Study',
  4: 'Unmoderated Task',
}

export const Types = {
  PRIVATE_PROJECT: 'ByoaProject',
  PUBLIC_PROJECT: 'Project',
};

export const ACCOUNT_DASHBOARD_PROJECT_STATUS_CATEGORIES = ["active", "all", "draft", "pending_close_request", "completed"] as const;

export const ACCOUNT_DASHBOARD_PROJECT_TYPES_CATEGORIES = ["Project", "ByoaProject"] as const;

export const ACCOUNT_DASHBOARD_ACCESS_TYPES_CATEGORIES = ["owner", "collaborator", "team_member"] as const;

export const StudyTypeBobEnumMap = {"ONE_ON_ONE":{"id":1,"key":"one_on_one","display_name":"1-on-1 Interview","display_noun":"interview","articled_noun":"an interview","css_class":"interview","icon_class":"fa-microphone","llm_tool_key":"one_on_one","transition":{}},"FOCUS_GROUP":{"id":2,"key":"focus_group","display_name":"Focus Group","display_noun":"focus group","articled_noun":"a focus group","css_class":"focus-group","icon_class":"fa-users","llm_tool_key":"focus_group","transition":{}},"MULTI_DAY":{"id":3,"key":"multi_day","display_name":"Multi Day Study","display_noun":"multi day study","articled_noun":"a multi day study","css_class":"multi-day","icon_class":"fa-calendar-days","llm_tool_key":"multi_day","transition":{}},"UNMODERATED_TASK":{"id":4,"key":"unmoderated_task","display_name":"Unmoderated Task","display_noun":"unmoderated task","articled_noun":"an unmoderated task","css_class":"unmoderated-task","icon_class":"fa-tasks","llm_tool_key":"unmoderated_task","transition":{}}} as const;

export const RESEARCHER_INCENTIVE_NOTE = "Participants in supported countries can redeem incentives in their local currency.<br/><a href='https://staging.userinterviews.com/support/incentive-and-currency-options' rel='noopener noreferrer' target='_blank'> Learn more</a> about supported reward options and currencies."

export const PROJECT_PARTICIPANT_STATUS_RUBY_ENUM =
  [
{ key: 'paid', id: 7, clientSorted: false, displayName: 'Paid', sortOrder: 1, clientFinalized: false },
{ key: 'interview_completed', id: 8, buttonText: 'Mark completed', clientSorted: false, displayName: 'Interview completed', sortOrder: 2, clientFinalized: true },
{ key: 'client_rescheduled', id: 12, clientSorted: false, displayName: 'Researcher rescheduled', sortOrder: 101, clientFinalized: false },
{ key: 'client_canceled', id: 5, clientSorted: false, displayName: 'Researcher canceled', sortOrder: 102, clientFinalized: false },
{ key: 'participant_rescheduled', id: 13, clientSorted: false, displayName: 'Participant rescheduled', sortOrder: 103, clientFinalized: false },
{ key: 'participant_canceled', id: 10, clientSorted: false, displayName: 'Participant canceled', sortOrder: 104, clientFinalized: false },
{ key: 'no_show', id: 9, clientSorted: false, displayName: 'Did not show', sortOrder: 105, clientFinalized: true },
{ key: 'confirmed', id: 6, clientSorted: false, displayName: 'Confirmed', sortOrder: 201, clientFinalized: false },
{ key: 'approved', id: 4, buttonText: 'Approve & invite', clientSorted: true, displayName: 'Approved', sortOrder: 301, clientFinalized: false },
{ key: 'potential', id: 16, clientSorted: false, displayName: 'Potential', sortOrder: 350, clientFinalized: false },
{ key: 'qualified', id: 2, clientSorted: false, displayName: 'Qualified', sortOrder: 401, clientFinalized: false },
{ key: 'qualified_needs_review', id: 14, clientSorted: false, displayName: 'Qualified (needs review)', sortOrder: 425, clientFinalized: false },
{ key: 'prequalified', id: 11, clientSorted: false, displayName: 'Pre-qualified', sortOrder: 450, clientFinalized: false },
{ key: 'rejected', id: 3, buttonText: 'Not a fit', clientSorted: true, displayName: 'Not a fit', sortOrder: 501, clientFinalized: false },
{ key: 'unqualified', id: 1, clientSorted: false, displayName: 'Unqualified', sortOrder: 502, clientFinalized: false },
{ key: 'unsorted', id: 0, clientSorted: false, displayName: 'Unsorted', sortOrder: 1000, clientFinalized: false },
{ key: 'fraudulent', id: 15, clientSorted: false, displayName: 'Fraudulent', sortOrder: 1001, clientFinalized: false }
];

export const PROJECT_PARTICIPANT_EMAILABLE_STATUS_RUBY_ENUM =
  [
{ key: 'paid', id: 7, clientSorted: false, displayName: 'Paid', sortOrder: 1, clientFinalized: false },
{ key: 'interview_completed', id: 8, buttonText: 'Mark completed', clientSorted: false, displayName: 'Interview completed', sortOrder: 2, clientFinalized: true },
{ key: 'client_rescheduled', id: 12, clientSorted: false, displayName: 'Researcher rescheduled', sortOrder: 101, clientFinalized: false },
{ key: 'client_canceled', id: 5, clientSorted: false, displayName: 'Researcher canceled', sortOrder: 102, clientFinalized: false },
{ key: 'participant_rescheduled', id: 13, clientSorted: false, displayName: 'Participant rescheduled', sortOrder: 103, clientFinalized: false },
{ key: 'participant_canceled', id: 10, clientSorted: false, displayName: 'Participant canceled', sortOrder: 104, clientFinalized: false },
{ key: 'no_show', id: 9, clientSorted: false, displayName: 'Did not show', sortOrder: 105, clientFinalized: true },
{ key: 'confirmed', id: 6, clientSorted: false, displayName: 'Confirmed', sortOrder: 201, clientFinalized: false },
{ key: 'approved', id: 4, buttonText: 'Approve & invite', clientSorted: true, displayName: 'Approved', sortOrder: 301, clientFinalized: false },
{ key: 'potential', id: 16, clientSorted: false, displayName: 'Potential', sortOrder: 350, clientFinalized: false },
{ key: 'qualified', id: 2, clientSorted: false, displayName: 'Qualified', sortOrder: 401, clientFinalized: false },
{ key: 'qualified_needs_review', id: 14, clientSorted: false, displayName: 'Qualified (needs review)', sortOrder: 425, clientFinalized: false },
{ key: 'prequalified', id: 11, clientSorted: false, displayName: 'Pre-qualified', sortOrder: 450, clientFinalized: false },
{ key: 'rejected', id: 3, buttonText: 'Not a fit', clientSorted: true, displayName: 'Not a fit', sortOrder: 501, clientFinalized: false },
{ key: 'unqualified', id: 1, clientSorted: false, displayName: 'Unqualified', sortOrder: 502, clientFinalized: false },
{ key: 'unsorted', id: 0, clientSorted: false, displayName: 'Unsorted', sortOrder: 1000, clientFinalized: false }
];

export const PROJECT_PARTICIPANT_ADMIN_PRE_CONFIRMED_STATUSES =
  ['unsorted', 'unqualified', 'qualified', 'rejected', 'approved', 'prequalified', 'qualified_needs_review', 'potential'];

export const PROJECT_PARTICIPANT_ADMIN_STATUSES =
  ['unsorted', 'unqualified', 'qualified', 'rejected', 'approved', 'confirmed', 'paid', 'interview_completed', 'no_show', 'prequalified', 'qualified_needs_review', 'fraudulent', 'potential'];

export const PROJECT_PARTICIPANT_CLIENT_FINALIZABLE_STATUSES =
  ['confirmed'];

export const PROJECT_PARTICIPANT_CLIENT_FINALIZED_STATUSES =
  ['interview_completed', 'no_show'];

export const PROJECT_PARTICIPANT_CLIENT_HIDDEN_STATUSES =
  ['unsorted', 'prequalified', 'qualified_needs_review'];

export const PROJECT_PARTICIPANT_CLIENT_SORTABLE_STATUSES =
  ['unqualified', 'qualified', 'rejected', 'approved', 'potential'];

export const PROJECT_PARTICIPANT_CLIENT_SORTED_STATUSES =
  ['rejected', 'approved', 'potential'];

export const PROJECT_PARTICIPANT_FINALIZED_AND_CONFIRMED_STATUSES =
  ['no_show', 'interview_completed', 'paid', 'fraudulent', 'confirmed'];

export const PROJECT_PARTICIPANT_NON_FINALIZED_STATUSES =
  ['unsorted', 'unqualified', 'qualified', 'rejected', 'approved', 'client_canceled', 'confirmed', 'participant_canceled', 'prequalified', 'client_rescheduled', 'participant_rescheduled', 'qualified_needs_review', 'potential'];

export const PROJECT_PARTICIPANT_PRE_APPROVED_STATUSES =
  ['unsorted', 'unqualified', 'prequalified', 'potential', 'qualified_needs_review', 'qualified', 'rejected'];

export const PROJECT_PARTICIPANT_ADVANCED_SCREENING_SCHEDULABLE_STATUSES =
  ['unqualified', 'qualified', 'approved', 'rejected', 'potential', 'client_rescheduled', 'participant_rescheduled'];

export const PROJECT_PARTICIPANT_SCHEDULED_STATUSES =
  ['participant_canceled', 'participant_rescheduled', 'client_canceled', 'client_rescheduled', 'confirmed', 'interview_completed', 'no_show', 'paid', 'fraudulent'];

export const PROJECT_PARTICIPANT_COMPLETED_ROLLBACK_STATUSES =
  ['fraudulent', 'no_show']

export const PROJECT_WORKSPACE_DEFAULT_PAGE_SIZE =
  50;

export const WORKSPACE_SECTION_ATTRIBUTES =
  {"details":{"path_name":"project_workspace_details","section":"details","text":"Project overview"},"participants":{"path_name":"project_workspace_participants","section":"participants","text":"Participants"},"characteristics":{"path_name":"project_workspace_characteristics","section":"characteristics","text":"Characteristics"},"screener":{"path_name":"project_workspace_survey","section":"screener","text":"Screener survey"},"invite_participants":{"path_name":"project_workspace_participants_invite","section":"invite_participants","text":"Invite participants"},"sessions":{"path_name":"project_workspace_sessions","section":"sessions","text":"Confirmed sessions"},"participant_tracking":{"path_name":"project_workspace_participant_tracking","section":"logistics","text":"Participant tracking"},"calendar":{"path_name":"project_workspace_calendar","section":"calendar","text":"Manage availability"},"messages":{"path_name":"project_workspace_messages","section":"messages","text":"Messages"},"emails":{"path_name":"project_workspace_emails","section":"emails","text":"Automated emails"},"collaborators":{"path_name":"project_workspace_collaborators","section":"collaborators","text":"Collaborators"},"branding":{"path_name":"project_workspace_branding","section":"branding","text":"Branding"},"billing":{"path_name":"project_workspace_billing","section":"billing","text":"Billing"},"settings":{"path_name":"project_workspace_staff_settings","section":"settings","text":"Settings"},"notifications":{"path_name":"project_workspace_staff_notifications","section":"notifications","text":"Tags \u0026 Notifications"},"payments":{"path_name":"project_workspace_staff_payments","section":"payments","text":"Payments"},"qa_overview":{"path_name":"project_workspace_staff_qa_overview","section":"qa_overview","text":"QA Overview"},"webhooks":{"path_name":"project_workspace_staff_webhooks","section":"webhooks","text":"Failed Webhooks"}};

export const ProjectAvailabilityModes = {
  AUTOMATIC: 'automatic',
  MANUAL: 'manual',
};

export const PROJECT_CONFIRMATION_NOTES_HTML_ALLOWED_TAGS =
  ["a", "br", "p", "em", "strong", "li", "ul", "ol"];

export const PROJECT_ADDITIONAL_RECRUITMENT_REQUIREMENTS_HTML_ALLOWED_TAGS =
  ["br", "p", "em", "strong", "li", "ul", "ol"];

export const ParticipantSources = {"2":"Project","3":"FileUpload","4":"ParticipantPopulationOptInForm","5":"ApiImport","6":"Account","7":"User"} as const;

export const MeetingBotAutoJoinDeltaMinutes = 5;

export const StaffEmailsPageSize = 200;

export const MAX_QUOTAS_PER_PROJECT = 10;
